export default function withDisabledNewlines(editor) {
  editor.insertBreak = () => {
    // do nothing
  };

  return editor;
}
